package com.appsyde.shared.modules.ticket.data.dto

import kotlinx.serialization.Serializable

@Serializable
data class TicketRespondResponseDto(
    val ticket: TicketRespondDto,
    val messages: List<TicketRespondMessageDto>,
    val draft: TicketDraftDto?,
    val inboundBody: String? = null
)

@Serializable
data class TicketRespondDto(
    val id: String,
    val threadId: String,
    val status: String,
    val statusSource: String = "AUTO",
    val needsResponse: Boolean,
    val clientEmail: String? = null,
    val subject: String? = null,
    val stateSummary: String?,
    val respondContext: String?,
    val detectedMemoryJson: String?,
    val missingKeysJson: String,
    val toConfirmKeysJson: String,
    val currentIntent: String?,
    val currentPriority: String?,
    val currentComplexity: String?,
    val currentSuggestedActionCode: String?,
    val currentSuggestedActionLabel: String?,
    val currentSuggestedActionWhy: String? = null,

    /** V1: key -> { source, updated_at } for source badges (agent_entered / agent_confirmed). */
    val detectedSourcesJson: String? = null,

    val currentDraftSuggestion: String? = null,
    val currentDraftSuggestionUpdatedAtMs: Long? = null,
    val currentDraftSourceMessageId: String? = null,

    val updatedAtMs: Long,
    val lastInboundSentAtMs: Long? = null,

    val hasHistory: Boolean = false,
    val historyCount: Int = 0,

    val assignedTo: AssignedToDto? = null,
    val writeLock: WriteLockDto? = null
)

@Serializable
data class TicketRespondMessageDto(
    val id: String,
    val direction: String,
    val sentAtMs: Long,
    val summary: String?,
    val bodyPreview: String?,
    val authorEmail: String?,
    val hasAttachments: Boolean,
    val originalBody: String? = null,
    val attachments: List<AttachmentDto> = emptyList()
)

@Serializable
data class AttachmentDto(
    val id: String,
    val filename: String,
    val mimeType: String,
    val sizeBytes: Long? = null
)

@Serializable
data class TicketDraftDto(
    val status: String,
    val body: String?,
    val updatedAtMs: Long?
)
